<template>
  <el-container class="relative table-page no-shrink-mobile">
    <aside class="filters-bar el-aside d-flex column sidebar-links">
      <router-link :to="'/class/'+$route.params.id"><span>Students</span></router-link>
      <router-link :to="'/assessment/'+$route.params.id"><span>Assessment</span></router-link>
      <div class="disabled-wrap"><router-link :to="'/analytics/'+$route.params.id" class="d-flex"><span>Analytics</span>
        <div class="premium"><img src="/static/premium.svg" alt=""><span>premium</span></div>
      </router-link></div>
      <div :class="{'disabled-wrap': isLoading || (currentClass.demos && !currentClass.demos.length)}">
        <router-link :to="'/tours/'+$route.params.id"><span>Tours</span></router-link>
      </div>
    </aside>
    <div class="el-main" v-loading="isLoading">
      <div class="headings">
        <h2 style="margin-top: 0; text-align: center">Class: {{ currentClass.name }}</h2>
        <div v-if="studentsData.length">
          <div class="d-flex justify-between align-end">
            <h3 style="margin: 0">Students</h3>
            <el-button type="success" @click="createStudentModal = true; studentName = ''">ADD STUDENT</el-button>
          </div>

          <el-dialog
                  class="signup-modal"
                  title="Edit student"
                  :visible.sync="editStudentModal"
                  width="30%"
                  center>
            <div class="flex-center">Enter student's name:</div>
            <div>
              <el-input placeholder="" v-model="studentName"
                        class="input-with-select search-cnt">
              </el-input>
            </div>
            <div class="d-flex justify-around" style="padding-top: 20px;">
              <el-button type="primary" @click.prevent='editStudent'>Save</el-button>
              <el-button type="success" @click.prevent='editStudentModal = false'>Cancel</el-button>
            </div>
          </el-dialog>

          <el-table
                  class="students-table"
                  :border="true"
                  :data="studentsData"
                  style="width: 100%; margin-top: 20px;">
            <!-- <el-table-column
                    :resizable="false"
                    prop="id"
                    label="ID"
                    width="50">
              <template slot-scope="scope">
                <div class="id-column">
                  <b class="hidden-sm-and-up">ID:</b> {{ scope.row.id }}
                </div>
              </template>
            </el-table-column> -->
            <el-table-column
                    :resizable="false"
                    prop="name"
                    column-key="Name"
                    label="Name">
              <template slot-scope="scope">
                <b class="hidden-sm-and-up">Name:</b> {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column
                    :resizable="false"
                    width="150"
                    prop="lastActivity"
                    label="Last Activity">
              <template slot-scope="scope">
                <b class="hidden-sm-and-up">Last Activity:</b> never
              </template>
            </el-table-column>
            <el-table-column
                    width="240"
                    :resizable="false"
                    align="center"
                    label="Actions">
              <template slot-scope="scope">
                <el-button
                        type="primary"
                        size="mini"
                        @click="handleView(scope.$index, scope.row)">View
                </el-button>
                <el-button
                        type="success"
                        size="mini"
                        @click="handleEdit(scope.$index, scope.row)">Edit
                </el-button>
                <el-button
                        size="mini"
                        type="danger"
                        @click="handleRemove(scope.$index, scope.row)">Delete
                </el-button>
              </template>
            </el-table-column>
          </el-table>

        </div>
        <div v-if="!studentsData.length && !isLoading" class="no-data-block">
          <div class="flex-center">
            <div class="step-block d-flex" @click="createStudentModal = true">
              <div class="step-number">
                <div><img src="/static/flag.svg" alt=""></div>
                <div>Step 2</div>
                <div class="bg-number">2</div>
              </div>
              <div class="step-name">
                Add a student
              </div>
            </div>
          </div>
          <div class="description">
            Here you can manage the list of students inside this class. Add your students to this page, so they can easily pick themselves from a list when your share the tour.
          </div>
          <div class="img-cnt flex-center">
            <img src="/static/add_student.png" alt="">
          </div>

          <div class="d-flex justify-center" style="margin-top: 20px;">
            <div class="btn-main shadowfloat" @click="createStudentModal = true">Add Student</div>
          </div>

        </div>

      </div>

    </div>

    <el-dialog
            class="signup-modal"
            title="Add student!"
            :visible.sync="createStudentModal"
            width="30%"
            center>
      <div class="flex-center">Enter student's name:</div>
      <div>
        <el-input placeholder="" v-model="studentName"
                  class="input-with-select search-cnt">
        </el-input>
      </div>
      <div class="d-flex justify-around" style="padding-top: 20px;">

        <el-button type="primary" @click.prevent='createStudent'>Submit</el-button>
        <el-button type="success" @click.prevent='createStudentModal = false'>Cancel</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    name: 'myClasses',
    data () {
      return {
        studentName: '',
        studentId: '',
        studentIndex: '',
        createStudentModal: false,
        editStudentModal: false,
        isLoading: true,
        currentClass: {
          name: ''
        },
        studentsData: [],
      }
    },
    mounted: function () {
      this.axios.get(this.$store.state.API_URL + 'class/' + this.$route.params.id)
        .then((res) => {
          this.currentClass = res.data;
          this.isLoading = false
        });

      this.axios.get(this.$store.state.API_URL + 'student?class=' + this.$route.params.id)
        .then((res) => {
          this.studentsData = res.data;
        });
    },
    methods: {
      createStudent() {
        this.axios.post(this.$store.state.API_URL + 'student', {name: this.studentName, class: this.currentClass.id})
          .then((res) => {
            this.studentsData.push(res.data);
            this.studentName = '';
            this.createStudentModal = false;
//            if (this.studentsData.length === 1) {
//              this.$router.push("/library");
//            }
          });
      },
      editStudent() {
        this.axios.put(this.$store.state.API_URL + 'student/' + this.studentId, {name: this.studentName})
          .then((res) => {
            this.studentsData[this.studentIndex].name = res.data.name;
            this.studentName = '';
            this.studentIndex = '';
            this.studentId = '';
            this.editStudentModal = false;
          });
      },
      handleView(index, row) {
        this.$router.push('/class/' + this.currentClass.id + '/' + row.id);
        console.log(index, row);
      },
      handleEdit(index, row) {
        this.studentName = row.name;
        this.studentId = row.id;
        this.studentIndex = index;
        this.editStudentModal = true;
        console.log(index, row);
      },
      handleRemove(index, row) {
        this.axios.delete(this.$store.state.API_URL + 'student/' + row.id)
          .then((res) => {
            this.studentsData.splice(index, 1);
          });
        console.log(index, row);
      },
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/pages/Class.vue